import { FormControl, Box, Typography, TextField, IconButton, Button } from "@mui/material";
import { useState } from "react";
import { CrossIcon } from "../../assets/icons";
import { LoadingButton } from "@mui/lab";
import Api from "../../openapi";
import { IOverlay } from "../../pages/Areas";
import { IZone } from "../../pages/Areas";
import { useDispatch } from "react-redux";
import { setNotification } from "../../store/notificationSlice";
import { AdminAreaResponse } from "../../openapi/client";
interface ICrudPanelProps {
  zone: Partial<IZone & IOverlay>;
  onClose: (cancel?: IZone | IOverlay) => void;
  onDelete: (zone: IZone) => void;
  onConfirm: (zone: any) => void;
  createArea: (area: AdminAreaResponse) => Promise<void>;
  updateArea: (area: AdminAreaResponse) => Promise<void>;
  mode: "edit" | "create";
}

export default function CrudPanel(props: ICrudPanelProps) {
  const dispatch = useDispatch();
  const [zone, setZone] = useState(props.zone);
  const [loading, setLoading] = useState(false);
  const [validation, setValidation] = useState({
    show: false,
    name: {
      error: !zone?.name || zone?.name?.trim() === "",
      helperText: "Please enter name",
    },
  });
  const handleFieldChange = (field: string, value: any) => {
    if (zone) {
      setZone({ ...zone, [field]: value });
    }

    // Update validation based on the field being changed
    if (field === "name") {
      setValidation({
        ...validation,
        name: {
          error: !value || value.trim() === "",
          helperText: "Please enter name",
        },
      });
    } else {
      setValidation({ ...validation, [field]: { error: false, helperText: "" } });
    }
  };

  const handleConfirm = async () => {
    if (validation.name.error) {
      setValidation({ ...validation, show: true });
      return;
    }

    if (props.mode === "edit") {
      try {
        setLoading(true);
        await props.updateArea({
          id: String(props.zone.id),
          name: zone.name,
          geometry: { coordinates: zone.coordinates?.map((c) => ({ lat: c.lat(), lon: c.lng() })) },
        });
        props.onConfirm(zone);
        dispatch(
          setNotification({
            show: true,
            severity: "success",
            message: "Area updated successfully",
          })
        );
      } catch (error: any) {
        console.error(error);
        dispatch(
          setNotification({
            show: true,
            severity: "error",
            message: error.response?.data?.message || error.message,
          })
        );
      } finally {
        setLoading(false);
      }
    } else if (props.mode === "create") {
      // try {
      //   const coordinates = (props.zone as IOverlay)?.getPaths().getArray();
      //   await props.createArea({
      //     name: zone.name,
      //     geometry: {
      //       coordinates: coordinates.flatMap((path) => path.getArray().map((c) => ({ lat: c.lat(), lon: c.lng() }))),
      //     },
      //   });
      //   props.onConfirm(zone);
      //   dispatch(
      //     setNotification({
      //       show: true,
      //       severity: "success",
      //       message: "Area created successfully",
      //     })
      //   );
      // } catch (error: any) {
      //   console.error(error);
      //   dispatch(
      //     setNotification({
      //       show: true,
      //       severity: "error",
      //       message: error.response?.data?.message || error.message,
      //     })
      //   );
      // } finally {
      //   setLoading(false);
      // }
    }
  };

  return (
    <FormControl sx={{ width: "100%" }}>
      <Box className="datatable-filter-header">
        <Box className="datatable-filter-header-text" sx={{ flex: "1 0 0" }}>
          {props.mode === "edit" ? "Edit Area" : "Create Area"}
        </Box>
        {props.mode === "edit" && (
          <IconButton
            aria-label="close"
            onClick={() => props.onClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 16,
              color: "text.fontLight2",
            }}
          >
            <CrossIcon height={20} width={20} />
          </IconButton>
        )}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "16px", padding: "16px" }}>
        <Box className="form-section">
          <Box sx={{ display: "flex" }}>
            <Typography component="span" className="form-label">
              Area Name
            </Typography>
            <Typography component="span" className="required-label">
              *
            </Typography>
          </Box>
          <TextField
            className="form-field"
            value={zone?.name}
            error={validation.show && validation.name?.error}
            helperText={validation.show && validation.name?.error ? validation.name.helperText : undefined}
            onChange={(e) => handleFieldChange("name", e.target.value)}
          />
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", gap: "16px", padding: "16px" }}>
        {props.mode === "edit" ? (
          <>
            <Button
              color="error"
              size="small"
              variant="contained"
              onClick={() => {
                props.onDelete(props.zone as IZone);
                props.onClose();
              }}
              sx={{ display: "flex", flex: "1 0 0" }}
            >
              Delete
            </Button>
            <LoadingButton
              fullWidth
              loading={loading}
              color="primary"
              size="small"
              variant="contained"
              sx={{ display: "flex", flexDirection: "column", flex: "1 0 0" }}
              onClick={handleConfirm}
            >
              Save
            </LoadingButton>
          </>
        ) : (
          <>
            <Button
              color="secondary"
              size="small"
              variant="contained"
              onClick={() => props.onClose(props.zone as IZone)}
              sx={{ display: "flex", flex: "1 0 0" }}
            >
              Delete
            </Button>
            <LoadingButton
              fullWidth
              loading={loading}
              color="primary"
              size="small"
              variant="contained"
              sx={{ display: "flex", flexDirection: "column", flex: "1 0 0" }}
              onClick={() => props.onConfirm(zone)}
            >
              Apply
            </LoadingButton>
          </>
        )}
      </Box>
    </FormControl>
  );
}
